import { Typography, styled } from "@mui/material";
import { useTranslation } from "react-i18next";
import { CalculationResult } from "src/types";

interface Props {
  calculationResult: CalculationResult;
}

export function CalculationType(props: Props) {
  const { calculationResult } = props;
  const { t } = useTranslation();

  return (
    <Styles>
      <Typography variant="h3">{t("label.calculationDetails")}</Typography>
      <Typography className="text-with-icon">
        {t("label.calculationMethod", {
          method: t(`label.${calculationResult.calculationType}`),
        })}
        {/* <Tooltip title={t`label.calculationResultExplanation_${calculationResult.calculationType}`}>
          <InfoIcon />
        </Tooltip> */}
      </Typography>
    </Styles>
  );
}

const Styles = styled("div")`
  background-color: ${(props) => props.theme.palette.background.paper};
  padding: ${({ theme }) => theme.spacing(2, 2)};
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(1)};
  .text-with-icon {
    display: inline-flex;
    gap: ${({ theme }) => theme.spacing(1)};
    align-items: flex-start;
  }
  svg {
    color: ${({ theme }) => theme.palette.grey[400]};
    font-size: 16px;
  }
`;
